import { pgTable, text, timestamp, uuid, uniqueIndex, index, smallint } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { conversations } from "./chat";
export var ConversationContextKind;
(function (ConversationContextKind) {
    ConversationContextKind["USER_PROFILE"] = "user_profile";
    ConversationContextKind["COMPANY_PROFILE"] = "company_profile";
    ConversationContextKind["METRIC"] = "metric";
    ConversationContextKind["WEBSITE_SNIPPET"] = "website_snippet";
    ConversationContextKind["INSIGHT"] = "insight";
    ConversationContextKind["EVENT"] = "event";
    ConversationContextKind["DOCUMENT"] = "document";
    ConversationContextKind["EMAIL"] = "email";
})(ConversationContextKind || (ConversationContextKind = {}));
export const conversationContextKinds = Object.values(ConversationContextKind);
export var ConversationContextSentiment;
(function (ConversationContextSentiment) {
    ConversationContextSentiment["POSITIVE"] = "positive";
    ConversationContextSentiment["NEGATIVE"] = "negative";
    ConversationContextSentiment["NEUTRAL"] = "neutral";
})(ConversationContextSentiment || (ConversationContextSentiment = {}));
export const conversationContext = pgTable("conversation_context", {
    id: uuid("id").primaryKey().defaultRandom(),
    conversationId: uuid("conversation_id")
        .notNull()
        .references(() => conversations.id, { onDelete: "cascade" }),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    kind: text("kind").notNull(),
    source: text("source").notNull(),
    label: text("label").notNull(),
    summary: text("summary").notNull(),
    detail: text("detail"),
    url: text("url"),
    score: smallint("score"),
    contextRefId: text("context_ref_id"),
    sentiment: text("sentiment"),
    lastUsedAt: timestamp("last_used_at", { withTimezone: true }).notNull().defaultNow(),
    lastRefreshedAt: timestamp("last_refreshed_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    conversationIdx: index("idx_conversation_context_conversation").on(table.conversationId),
    companyIdx: index("idx_conversation_context_company").on(table.companyId, table.lastUsedAt),
    uniqueConversationContext: uniqueIndex("uniq_conversation_context_key").on(table.conversationId, table.kind, table.source, table.label, table.contextRefId),
}));
